import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useState, useEffect } from "react";

import {
  Context,
  fetchPulseSurveyQuestionsWithAnswers,
  updatePulseSurveyAnswer,
  deletePulseSurveyAnswer,
  UPDATE_PULSE_SURVEY_ANSWER_SUCCESS_MESSAGE,
  UPDATE_PULSE_SURVEY_ANSWER_FAILURE_MESSAGE,
  DELETE_PULSE_SURVEY_ANSWER_SUCCESS_MESSAGE,
  DELETE_PULSE_SURVEY_ANSWER_FAILURE_MESSAGE,
} from "../../../store/student";
import { useWaitApiCall } from "../../../hooks/useWaitApiCall";
import useToast from "../../../hooks/useToast";
import {
  IPulseSurveyAnswer,
  PulseSurveyQuestionWithAnswer,
} from "../../../state";
import FabButton from "../../../atoms/FabButton";
import FiltableHeader from "../../../organisms/FiltableHeader";
import RealizationPulseSurvey from "../../../templates/RealizationPulseSurvey";
import ModalConfirm from "../../../molecules/ModalConfirm";
import PulseSurveyAnswerModal from "../../../organisms/PulseSurveyModal/Answer";
import Toast from "../../../molecules/Toast";
import styles from "../common.module.scss";

const RealizationPulseSurveyPage = () => {
  const { dispatch, contextState } = useContext(Context);
  const [calling, peep] = useWaitApiCall(contextState);

  useIonViewWillEnter(() => {
    dispatch(fetchPulseSurveyQuestionsWithAnswers());
  });

  const [state, setState] = useState({
    searching: false,
    searchText: "",
  });

  const [editingItem, setEditingItem] =
    useState<PulseSurveyQuestionWithAnswer | null>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const { toast, setToast, handleToast } = useToast();

  useEffect(() => {
    const successMessages = [
      UPDATE_PULSE_SURVEY_ANSWER_SUCCESS_MESSAGE,
      DELETE_PULSE_SURVEY_ANSWER_SUCCESS_MESSAGE,
    ];
    const errorMessages = [
      UPDATE_PULSE_SURVEY_ANSWER_FAILURE_MESSAGE,
      DELETE_PULSE_SURVEY_ANSWER_FAILURE_MESSAGE,
    ];

    if (successMessages.includes(contextState.success_message)) {
      dispatch(fetchPulseSurveyQuestionsWithAnswers());
    }

    handleToast("success", contextState.success_message, successMessages);
    handleToast("danger", contextState.error, errorMessages);
  }, [contextState.success_message, contextState.error, dispatch, handleToast]);

  const handleEdit = (item: PulseSurveyQuestionWithAnswer) => {
    setEditingItem(item);
    setIsEditModalOpen(true);
  };

  const handleDelete = (item: PulseSurveyQuestionWithAnswer) => {
    setEditingItem(item);
    setIsDeleteConfirmOpen(true);
  };

  const handleUpdateSubmit = (answers: IPulseSurveyAnswer) => {
    if (editingItem) {
      dispatch(
        peep(
          updatePulseSurveyAnswer(editingItem.answer.id, {
            pulse_survey_question_score: answers.score,
            pulse_survey_question_reason: answers.reason,
            tomorrow_plan: answers.tomorrow_plan,
          }),
        ),
      );
    }
    setIsEditModalOpen(false);
    setEditingItem(null);
  };

  const handleConfirmDelete = () => {
    if (editingItem) {
      dispatch(peep(deletePulseSurveyAnswer(editingItem.answer.id)));
    }
    setIsDeleteConfirmOpen(false);
    setEditingItem(null);
  };

  return (
    <IonPage>
      <FiltableHeader
        title="デイリーストック"
        unreadNotiCount={0}
        searching={state.searching}
        searchText={state.searchText}
        setState={setState}
        goBack
      />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <RealizationPulseSurvey
            state={state}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </div>
      </IonContent>
      <FabButton />
      <PulseSurveyAnswerModal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setEditingItem(null);
        }}
        onSubmitAnswers={handleUpdateSubmit}
        editData={editingItem}
      />
      <ModalConfirm
        isOpen={isDeleteConfirmOpen}
        loading={calling}
        message="このデイリーストックを削除しますか？"
        buttons={[
          {
            title: "キャンセル",
            type: "None",
            action: () => {
              setIsDeleteConfirmOpen(false);
              setEditingItem(null);
            },
          },
          {
            title: "削除",
            type: "Danger",
            action: handleConfirmDelete,
          },
        ]}
        onClose={() => {
          setIsDeleteConfirmOpen(false);
          setEditingItem(null);
        }}
      />
      <Toast
        type={toast.type}
        showToast={toast.isShow}
        onClose={() => setToast({ ...toast, isShow: false })}
        message={toast.message}
      />
    </IonPage>
  );
};

export default RealizationPulseSurveyPage;
